import notFound from '@images/404.svg';
import type React from 'react';
import { useTranslation } from 'react-i18next';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col justify-start items-center w-full mt-16 text-gray-600'>
      <img src={notFound} alt='not-found-image' />
      <div className='mt-[72px]'>
        <span className='max-w-xs mx-auto mb-6 text-center text-sm font-light'>
          {t('not-found.state')}
        </span>
      </div>
    </div>
  );
};
